import { useDispatch, useSelector } from 'react-redux';
import { handleOpenModelError, modelErrorSelector } from '../../entities/ComponentsSlice';
import ButtonBlack from '../../features/button-black/ButtonBlack';
import ButtonClose from '../../features/button-close/ButtonClose';
import Portal from '../../shared/portal/Portal';
import style from './ModalError.module.scss';

function ModalError() {
  const openModelError = useSelector(modelErrorSelector);
  const dispatch = useDispatch();

  const handleCloseModelError = () => {
    dispatch(handleOpenModelError(false));
  };
  return (
    <>
      {openModelError && (
        <Portal>
          <div className={style.modalErrorContainer}>
            <div className={style.modalErrorBack} />
            <div className={style.modalErrorBox}>
              <ButtonClose className={style.modalErrorBtn} handleFuction={handleCloseModelError} id='close_black' />
              <div className={style.modalErrorTitle}>Ошибка</div>
              <div className={style.modalErrorText}>
                Сервер временно недоступен, пожалуйста, повторите запрос позже.
              </div>
              <ButtonBlack className={style.modalErrorBtnClose} handleFuction={handleCloseModelError} text='Закрыть' />
            </div>
          </div>
        </Portal>
      )}
    </>
  );
}

export default ModalError;
